/* eslint-disable filenames/match-exported */
import { useMemo } from 'react';
import i18next from 'i18next';
import { I18nextProvider, Trans, initReactI18next, useTranslation,
// warning: undocumented API. Please refer to fe-modules#292 for details.
getI18n } from 'react-i18next';
import * as ReactI18next from 'react-i18next';
import createNestedTranslate
// For api-extractor cannot dynamic import error.
/* eslint-disable @typescript-eslint/no-unused-vars */

/* eslint-enable @typescript-eslint/no-unused-vars */ from "./createNestedTranslate";
export { initReactI18next, getI18n as getReactI18nextInstance, I18nextProvider, Trans, ReactI18next };

/**
 * init i18next
 * @param options - i18n init options. (https://www.i18next.com/overview/configuration-options#languages-namespaces-resources)
 */
export function init(options) {
  return i18next.use(initReactI18next).init({
    fallbackLng: false,
    load: 'currentOnly',
    interpolation: {
      escapeValue: false
    },
    keySeparator: false,
    // make resource loading in sync
    initImmediate: false,
    ...options
  });
}
export const translate = createNestedTranslate(i18next.t.bind(i18next));
export const useTranslator = (...args) => {
  const {
    t
  } = useTranslation(...args);
  return useMemo(() => createNestedTranslate(t), [t]);
};
export default i18next;